import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const Avatar = ({ className }: { className?: string }) => {
  return (
    <div
      className={twMerge("h-10 w-10 rounded-full bg-neutral-200", className)}
    />
  );
};

const Image = ({ className }: { className?: string }) => {
  return (
    <div
      className={twMerge(
        "aspect-video w-full rounded-sm bg-neutral-200",
        className,
      )}
    />
  );
};

const Container = ({
  onClick,
  children,
  className,
}: {
  onClick?: () => void;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={twMerge("flex animate-pulse gap-2", className)}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

const Text = ({ className }: { className?: string }) => {
  return (
    <div
      className={twMerge("h-3.5 w-full rounded-sm bg-neutral-200", className)}
    />
  );
};

export {
  Container as Skeleton,
  Container as SkeletonContainer,
  Avatar as SkeletonAvatar,
  Image as SkeletonImage,
  Text as SkeletonText,
};
